import { ADD_APPROVER_REQUEST, ADD_APPROVER_SUCCESS, ADD_APPROVER_FAILURE, ADD_APPROVER_RESET } from "../../actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const addApproverReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_APPROVER_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case ADD_APPROVER_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case ADD_APPROVER_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        case ADD_APPROVER_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default addApproverReducer;
